import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['expandIcon', 'expansible', 'header'];
  static classes = ['openIcon', 'closeIcon', 'expansibleOpen', 'expansibleClosed'];
  static values = {
    isOpen: Boolean,
  };

  toggle(event) {
    const targetIsNotALink = !event.target.closest('a');

    if (targetIsNotALink) {
      this.opened = !this.opened;
    }
  }

  get opened() {
    return this.isOpenValue;
  }

  set opened(opened) {
    this.isOpenValue = opened;

    if (this.hasExpansibleTarget) {
      if (this.expansibleOpenClass) {
        this.expansibleTarget.classList.toggle(this.expansibleOpenClass, this.isOpenValue);
      }
      if (this.expansibleClosedClass) {
        this.expansibleTarget.classList.toggle(this.expansibleClosedClass, !this.isOpenValue);
      }
    }

    if (this.hasExpandIconTarget) {
      if (this.closeIconClass) {
        this.expandIconTarget.classList.toggle(this.closeIconClass, this.isOpenValue);
      }
      if (this.openIconClass) {
        this.expandIconTarget.classList.toggle(this.openIconClass, !this.isOpenValue);
      }
    }
  }
}
